import React from "react";
import Form from "./Form/Form";
import AccountUsers from "../AccountUsers/AccountUsers";
import { getValueWithoutSpaces } from "Source/util/strings";
import { connect } from "react-redux";

@connect(store => {
    return {
        project: store.project,
        workstreamForm: store.workstreamForm,
        workstreams: store.workstreams,
    };
})

class AddWorkstream extends React.Component {
    render() {
        const { project, workstreamForm, workstreams } = this.props;

        if (!project.Selected.id) {
            return null;
        }

        const accountNameSuffix = project.Selected.email;
        const isEdit = !!workstreams.selected.id;

        return (
            <React.Fragment>
                <div class="modal fade bg-overlay add-modal mediumWidth" data-backdrop="static" data-keyboard="false" id="addWorkstreamModal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <Form 
                                location={ this.props.location } 
                                workstreamForm={workstreamForm}
                                workstreams={workstreams}
                                isEdit={isEdit}
                                accountNameSuffix={accountNameSuffix}
                            />
                        </div>
                    </div>
                </div>
                <AccountUsers />
            </React.Fragment>
        );
    }
}

export default AddWorkstream;
